import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-manual-quiz-progress-dialog-box',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './manual-quiz-progress-dialog-box.component.html',
	styleUrl: './manual-quiz-progress-dialog-box.component.scss'
})
export class ManualQuizProgressDialogBoxComponent {
	@Input() progress: number = 0;

	constructor(
		public dialogRef: MatDialogRef<ManualQuizProgressDialogBoxComponent>
	) { }

}